export default {
  getTeamMembers: (state) => {
    return state.teamMembers
  },
}
